/**
 * Created by kubla on 11/04/17.
 */
import Config from "../../config-app/config";

export default {

  RUOLI: ["", "P", "D", "C", "A"],
  RUOLI3: ["", "POR", "DIF", "CEN", "ATT"],
  RUOLI_LEGA: ["", "nP", "nD", "nC", "nA"],

  RUOLO: {
    P: 1,
    D: 2,
    C: 3,
    A: 4
  },

  RUOLI_NEW: {
    1: {
      ruolo_id: 1,
      abc: "P",
      plurale: "Portieri",
      n: "nP"
    },
    2: {
      ruolo_id: 2,
      abc: "D",
      plurale: "Difensori",
      n: "nD"
    },
    3: {
      ruolo_id: 3,
      abc: "C",
      plurale: "Centrocampisti",
      n: "nC"
    },
    4: {
      ruolo_id: 4,
      abc: "A",
      plurale: "Attaccanti",
      n: "nA"
    },
  },

  RUOLI_MANTRA: {
    "_1": {
      label: "P",
      descr: "Portiere"
    },
    "_2": {
      label: "DD",
      descr: "Terzino Dx"
    },
    "_3": {
      label: "DC",
      descr: "Difensore Centrale"
    },
    "_4": {
      label: "DS",
      descr: "Terzino Sx"
    },
    "_12": {
      label: "B",
      descr: "Braccetto"
    },
    "_5": {
      label: "E",
      descr: "Esterno"
    },
    "_6": {
      label: "M",
      descr: "Centrocampista Difensivo"
    },
    "_7": {
      label: "C",
      descr: "Centrocampista Centrale"
    },
    "_8": {
      label: "W",
      descr: "Ala"
    },
    "_9": {
      label: "T",
      descr: "Trequartista"
    },
    "_10": {
      label: "A",
      descr: "Attaccante"
    },
    "_11": {
      label: "PC",
      descr: "Punta Centrale"
    },
  },

  RUOLO_DA_CHIAMARE: {
    QUALUNQUE: 0,
  },

  PLAN_ASSOCIAZIONE: {
    AUTO: 1,
    MANU: 2,
    NO: 3,
  },

  PLAN_ASSOCIAZIONE_DESCR: {
    AUTO: 'Nel primo slot libero',
    MANU: 'Chiedimelo sul momento',
    NO: 'Non inserirlo, faccio io a mano',
  },

  ASTA_MODE: {
    SELVAGGIA: 2,
    POKER: 0,
    BUSTA_CHIUSA: 3,
    ASSEGNA: 1,
  },

  TIPO_RUOLI: {
    CLASSIC: "classic",
    MANTRA: "mantra",
  },

  ASTA_STATUS: {
    NOT_RUNNING: 0,
    RUNNING: 1
  },

  NO_ADMIN: '',

  OFFERTA: {
    PASSO_FORZATO: -3, // not used yet
    CREDITI_INSUFFICIENTI: -2, // not used yet
    INIT: -1, // diego: per me meglio se INIT = 0, PASSO = -1
    PASSO: 0,
    MINIMA: 1,
    RILANCIO: 5,
  },

  RILANCIO_MIN: 1,
  RILANCIO_MEDIO: 5,

  PRESENCE_STATES: {
    ONLINE: "online",
    OFFLINE: "offline",
    IDLE: "idle",
    AWAY: "away",
    PENDING: "pending",
    RESET: "reset",
  },

  MESSAGE_TYPE: {
    CHAT: 1,
    LOG: 2
  },

  COLORS: [
    "#ff8279",
    "#2196F3",
    "#7CB342",
    "#FF9800",
    "#FFEB3B",
    "#EC407A",
    "#BA68C8",
    "#FF5722",
    "#26A69A",
    "#AFB42B",
    "#9FA8DA",
    "#FFE082",
    "#607D8B",
    "#A1887F",
    "#9CCC65",
    "#BDBDBD",
    "#757575",
    "#6D4C41",
    "#2E7D32",
    "#303F9F",
  ],

  // ASTA_TABS : {
  //   MAIN: 1,
  //   SVIN: 2,
  //   ROSE: 3,
  //   CHAT: 4
  // },

  ASTA_MSG: {
    ASSEGNA: 1,
    ANNULLA: 2,
    ALTRO: 3
  },

  LOG_PAGINATOR: 10,

  LOG_TYPE: {

    ASSIGN: 1,
    REMOVE: 2,
    EDIT: 3,
    ESCLUSIONE_ASTA_ADMIN: 4,

    SCARTATO: 6,
    CREDITI_SQUADRA: 7,
    CALCIATORE_IN_ASTA: 8,
    ROUND_STOP: 9,

    ESCLUSIONE_ASTA: 10,
    RIAMMISSIONE_ASTA: 11,
    PASSO_FORZATO: 12,
    ROUND_START: 13,
    ROUND_PAUSE: 14,

    ALLINEA_ROSE_START: 15,
    ALLINEA_ROSE_END: 16,
    ALLINEA_ROSE_SKIP: 17,
    ALLINEA_ROSE_ERROR: 18,
    ROSE_IMPORTED: 19,
    ROSE_EXPORTED: 24,
    SALVA_ROSE: 20,

    REMOVE_SCARTATO: 21,
    REMOVE_SCARTATI: 22,

    EDIT_CREDITI_EXTRA: 23,
  },

  SQUADRE_SIZE: {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large"
  },

  SQUADRE_ORIENTATION: {
    VERTICAL: "vertical",
    HORIZONTAL: "horizontal",
  },

  TAVOLO_SIZE: {
    SMALL: "small",
    MEDIUM: "medium",
    LARGE: "large"
  },

  TAVOLO_LAYOUT: {
    CERCHIO: "cerchio",
    GRIGLIA: "griglia"
  },

  CHOOSER_MODE: {
    AUTO: "auto",
    MANUAL: "manual",
    MANUAL_PASSO: "manual_passo",
    ADMIN: "admin"
  },

  RANDOM_MODE: {
    ENABLED: 1,
    DISABLED: 0
  },

  CHOOSER_LIST_ORDER: {
    QUOTAZIONE: "q",
    NOME: "nome"
  },

  BASE_ASTA: {
    UNO: "1",
    QUOTAZIONE: "q"
  },

  OFFERTA_AUTO: {
    ENABLED: 1,
    DISABLED: 0
  },

  NRUOLI_OP: {
    ILLIMITATI: 'illimitati',
    ESATTAMENTE: '='
  },

  ROUND_STEP: {
    OFFERTE: 1,
    BUSTE: 2
  },

  LIMIT_SQUADRE_LAYOUT_CERCHIO: 10,

  NUM_ASSEGNAZIONI_FREE: 30,

  LS_ANNO_STATS: "annoStats_" + Config.TORNEO_ID,
  LS_HOME_AWAY: "homeAway_" + Config.TORNEO_ID,

  HOME_AWAY_ARY: ['home', 'away', 'homeAway'],
}